import { render } from "./devis.vue?vue&type=template&id=90867a0e&scoped=true"
import script from "./devis.vue?vue&type=script&lang=js"
export * from "./devis.vue?vue&type=script&lang=js"

import "./devis.vue?vue&type=style&index=0&id=90867a0e&lang=scss&scoped=true"

import exportComponent from "/usr/src/test-oho-sales/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-90867a0e"]])

export default __exports__